/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type Locale } from '@/types/i18n';
import { type BooleanForteFlagName } from './interface';

export const FORTE_FLAGS_DISABLED_TRUE_DEFAULT: Partial<Record<BooleanForteFlagName, Locale[]>> = {
  pdpRedesignEnabled: ['pt-BR'],
  useOMSInventoryQohService: ['en-US', 'es-MX', 'pt-BR'],
};
